import React, { useEffect } from 'react';
import { Image } from 'expo-image';
import { Asset } from 'expo-asset';
import { ONBOARDING_ARTWORK } from '@/constants/onboardingArtwork';

export default function OnboardingIllustration({ step = 0, size = 96, prefetch = false }) {
  const index = Math.max(0, ONBOARDING_ARTWORK.findIndex(item => item.step === step));
  const artwork = ONBOARDING_ARTWORK[index];
  useEffect(() => {
    if (!prefetch) return;
    const next = ONBOARDING_ARTWORK.slice(index + 1, index + 4);
    next.forEach(item => {
      const uri = Asset.fromModule(item.source).uri;
      Image.prefetch?.(uri, { cachePolicy: 'memory-disk' }).catch(() => {});
    });
  }, [index, prefetch]);
  return <Image source={artwork.source} contentFit="contain" priority="high" cachePolicy="memory-disk" accessibilityLabel={artwork.label} style={{ width: size, height: size, flexShrink: 0 }} />;
}
